import axios from 'axios';
import { config } from './config';

// Create axios instance
// In development: use relative paths so requests go through the proxy (setupProxy.js)
// In production: use absolute URL from config
// API calls should include /api/ prefix (e.g., /api/auth/login)
const isDevelopment = process.env.NODE_ENV === 'development';
const apiClient = axios.create({
  baseURL: isDevelopment ? '' : config.API_URL, // Empty in dev to use proxy, full URL in prod
  headers: {
    'Content-Type': 'application/json',
  },
});

// Debug: Log the actual baseURL being used
console.log('API Client baseURL:', apiClient.defaults.baseURL || '(relative - using proxy)');
console.log('Config API_URL:', config.API_URL);
console.log('Environment:', process.env.NODE_ENV);

// Add auth token to all requests and log the full URL
apiClient.interceptors.request.use((requestConfig) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    requestConfig.headers.Authorization = `Bearer ${token}`;
  }
  // Debug: Log the full URL being requested
  const fullUrl = (requestConfig.baseURL || '') + (requestConfig.url || '');
  console.log(`API Request: ${requestConfig.method?.toUpperCase()} ${fullUrl}`);
  return requestConfig;
});

// Handle response errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Avoid logging users out on every 401 (e.g., permission checks)
    // Only clear token for auth endpoints
    const url = error.config?.url || '';
    if (error.response?.status === 401 && url.startsWith('/api/auth/')) {
      localStorage.removeItem('access_token');
    }
    return Promise.reject(error);
  }
);

export default apiClient;
